module.exports = __webpack_public_path__ + "static/media/0019t.10fe6dec.jpg";